import axios from 'axios'
import { API_URL } from './Cnx'

const REQUEST_URL = 'api/empresas_externas'

export const getEmpresasExternas = q =>
  axios.get(`${API_URL}/${REQUEST_URL}/`, { params: q })
